/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Ott-common */
import InteractiveElement from '@dtvgo/interactive-element';

/* Other */
import { getJsonImage } from 'src/theme/images';

/* Utils */
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';
import chevronRight from '../../assets/svg/chevron-right.svg';

/* Style */
import './FocusableEditNameProfile.scss';

function EditNameProfile({
  className,
  profile,
  focused,
  onMouseDown,
  onMouseEnter,
}) {
  return (
    <InteractiveElement
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
      className={`data-div ${className} ${
        focused ? 'data-div--focused' : ''
      }`}
    >
      <div className="">
        <p id="name">
          <FormattedMessage id="profile.name.nickname" />
        </p>
      </div>
      <div className="name-profile">
        <div>
          { profile }
        </div>
        <img src={getJsonImage('chevron-left') || chevronRight} alt="Chevron Right" />
      </div>
    </InteractiveElement>
  );
}

EditNameProfile.defaultProps = {
  className: '',
  profile: '',
  focused: false,
  onMouseDown: undefined,
  onMouseEnter: undefined,
};

EditNameProfile.propTypes = {
  className: PropTypes.string,
  profile: PropTypes.string,
  focused: PropTypes.bool,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
};

export default memo(withInteractiveFocusable()(memo(EditNameProfile)));
